import { PremiumServiceParticipantsLimit } from "@/enums/PremiumServiceParticipantsLimit";
import { PremiumServiceEventTypes } from "@/enums/PremiumServiceEventTypes";
import { DefaultEmailTemplateType } from "@/enums/DefaultEmailTemplateType";
import { timeFormat } from "@/consts/DateTimeFormats";
import { EventStatus } from "@/enums/EventStatus";
import {VendorsTypes} from "@/enums/VendorsTypes";

export const ConciergeServiceMixin = {
  computed: {
    selectedFacility() {
      return this.$store.state.facilityModule.selectedFacility;
    },
    currentFacility() {
      return this.$store.state.authModule.currentFacility;
    },
    facilityCurrency() {
      return this.$store.getters.facilityCurrency;
    },
    PremiumServiceEventTypes() {
      return PremiumServiceEventTypes;
    },
    PremiumServiceParticipantsLimitTypes() {
      return PremiumServiceParticipantsLimit;
    },
    vendorEnabledEmailTemplates() {
      return this.$store.state.facilityModule.currentEmailTemplates.filter(x => x.isEnabled === true && x.type == DefaultEmailTemplateType.ServiceRequestToVendor);
    },
    currentVendors() {
      return this.$store.state.additionalServicesModule.currentVendors.filter(x => x.type === VendorsTypes.Concierge);
    },
    isHourFormat24() {
      return this.$store.state.facilityModule.selectedFacility.timeFormat === timeFormat.h24;
    },
    eventStatus() {
      return EventStatus;
    }
  }
}